const NAME = "FESTIVITIES_TABLE";

export default NAME;
